import StateFilteredAddress from '../forms/address/StateFilteredAddress';
import { StateFilterData } from '../forms/address/types';
import FormHandler from '../forms/FormHandler';
import LevelFirstFormPostHandler from './LevelFirstFormPostHandler';
import type { AddMembershipResponse } from './LevelFirstFormService';
import { IViewItemAnalytics } from '../analytics/types';
import fireAddToCartAnalytics from '../analytics/fireAddToCartAnalytics';
import navigateTo from '../utils/BrowserNavigation';

class LevelFirstForm {
  private viewItemAnalytics: IViewItemAnalytics | undefined;

  private membershipPrice: number;

  constructor(
    $form: HTMLFormElement,
    stateFilterData: StateFilterData,
    viewItemAnalytics: IViewItemAnalytics | undefined,
    membershipPrice: number,
  ) {
    this.viewItemAnalytics = viewItemAnalytics;
    this.membershipPrice = membershipPrice;

    const formHandler = new FormHandler($form, {
      postHandler: LevelFirstFormPostHandler,
      onValidationSuccess: ({ data, stopSubmitting }) => {
        const response = data as AddMembershipResponse;

        if (response.isSuccessful) {
          fireAddToCartAnalytics(this.viewItemAnalytics, [
            { price: this.membershipPrice, quantity: 1, itemVariant: '' },
          ]);
          navigateTo(response.redirectUrl!);
          return;
        }

        if (response.errorMessage) {
          formHandler.addErrorMessage(response.errorMessage, true);
        }

        stopSubmitting();
      },
    });

    StateFilteredAddress.createForCustomFormFields($form, formHandler, stateFilterData);
  }
}

export default LevelFirstForm;
